import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileIfc.tsx
const IconFileIfc = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M2 2h11.5v4A1.5 1.5 0 0 0 15 7.5h4V8h-9a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h9v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M14.5 2.5V6a.5.5 0 0 0 .5.5h3.5z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#2bbaa9",
			fillRule: "evenodd",
			d: "M10 9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm8.33 6.034q.34.132.767.132.582 0 .96-.258.384-.264.618-.744l-.744-.432q-.096.258-.3.444-.198.18-.534.18-.402 0-.648-.258-.24-.264-.24-.762v-.672q0-.498.24-.756a.84.84 0 0 1 .648-.264q.342 0 .516.162.18.156.264.42l.786-.408q-.228-.51-.606-.744-.378-.24-.96-.24-.426 0-.768.144a1.54 1.54 0 0 0-.582.426 1.9 1.9 0 0 0-.372.69 3 3 0 0 0-.132.936q0 .534.132.936.132.396.372.666.24.264.582.402m-7.005.06v-.726h.54v-2.736h-.54v-.726h1.992v.726h-.54v2.736h.54v.726zm2.752 0v-4.188h2.778v.81h-1.866v.858h1.59v.804h-1.59v1.716z",
			clipRule: "evenodd"
		})
	]
});
var IconFileIfc_default = forwardRef(IconFileIfc);
//#endregion
export { IconFileIfc_default as default };
